
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/resonate",
      function () {
        return require("private-next-pages/destinations/resonate.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/resonate"])
      });
    }
  